export const IsClef = (gabc: string) => {
  const clef = /[cf][1-5]/;
  const flattedClef = /[cf]b[1-5]/;
  return clef.test(gabc) || flattedClef.test(gabc);
};
